module.exports = __webpack_public_path__ + "media/images/flags/16/Netherlands-7c5dee5910d1d4e15a4c35d79d3b17bd.png";